import { assertEnvVariableExists } from '@tmh-website/shared/helpers';

export const resolveWeb2CasePayloadCaptchaSettings = (): string => {
  assertEnvVariableExists('NEXT_PUBLIC_SALESFORCE_W2C_ORG', process.env.NEXT_PUBLIC_SALESFORCE_W2C_ORG);

  return JSON.stringify({
    keyname: 'reCAPTCHA_v2_apollo',
    fallback: 'true',
    orgId: process.env.NEXT_PUBLIC_SALESFORCE_W2C_ORG,
    ts: `${new Date().getTime()}`,
  });
};

export const resolveWeb2CasePayloadOrgId = (): string => {
  assertEnvVariableExists('NEXT_PUBLIC_SALESFORCE_W2C_ORG', process.env.NEXT_PUBLIC_SALESFORCE_W2C_ORG);
  return process.env.NEXT_PUBLIC_SALESFORCE_W2C_ORG;
};

export const resolveWeb2CasePayloadRetUrl = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.href;
  } else {
    assertEnvVariableExists('NEXT_PUBLIC_ORIGIN', process.env.NEXT_PUBLIC_ORIGIN);
    return process.env.NEXT_PUBLIC_ORIGIN;
  }
};

export const resolveWeb2CasePayloadSubject = (w2cName: string, issueType?: string): string => {
  let subject: string = `${w2cName} ${issueType}`;

  if (typeof window !== 'undefined') {
    const currentUrl: URL = new URL(window.location.href);
    subject = `${subject} (${currentUrl.hostname})`;
  }

  return subject;
};

export const generateDescription = (values: any, fieldLabels: Record<string, string>): string => {
  return Object.keys(values).reduce((acc, key) => {
    if (fieldLabels[key]) {
      // Filter out undefined labels
      return `${acc}${fieldLabels[key]}: ${values[key]} \n\n`;
    }
    return acc;
  }, '');
};
